// extracted by mini-css-extract-plugin
export default {"gnb":"Gnb_gnb__2+9Qr"};